export const flipSign = (num: number) => num * -1;
